import api from './api';
import { API_URL } from './base';

export const fetchProductList = (page, perPage, productSearchFilters) => {
    let url = `${API_URL}/admin/products/?page=${page}&size=${perPage}`;
    if (productSearchFilters.searchText) {
        url = `${url}&q=${productSearchFilters.searchText}`;
    }
    return api.get(url).then(resp => {
        return resp.data;
    });
};

export const fetchProductById = (id) => {
    return api
        .get(`${API_URL}/admin/product/${id}`)
        .then(resp => {
            return resp.data;
        });
};

export const editProduct = (id,data) => {
    return api
        .put(`${API_URL}/admin/product/${id}/`, data)
        .then(resp => {
            return resp.data;
        });
};

export const addProduct = (data) => {
    return api
        .post(`${API_URL}/admin/product/`, data)
        .then(resp => {
            return resp.data;
        });
};

export const fetchProductDropdownList = () => {
    let url = `${API_URL}/admin/product-list`;
    return api.get(url).then(resp => {
        return resp.data;
    });
};

export const deleteProductById = id => {
    return api.delete(`${API_URL}/admin/product/${id}/`).then(resp => {
        return resp.data;
    });
};
